<template>
  <div id="admin">
    <div class="row mt-4">
      <div class="col-md-3">
        <AdminNav />
      </div><!-- /.col-md-3 -->
      <div class="col-md-9">
        <div class="container">
          <div v-if="admin.panel == 'dashboard'">
            <h1>Real Time Hospitality</h1>
            <hr>
            <router-link
              :to="{ name: 'Dashboard', params: {id: dashboard.data.id} }"
              class="btn btn-outline-light"
              target="_blank"
            >Launch Dasshboard <i class="fas fa-external-link-alt"></i></router-link>
            <router-link
              :to="{ name: 'Dashboard TV', params: {id: dashboard.data.id} }"
              class="btn btn-outline-light"
              target="_blank"
            ><i class="fas fa-tv"></i> Launch Signage Mode <i class="fas fa-external-link-alt"></i></router-link>
          </div><!-- /Dashboard Home -->
          <Design
            v-if="admin.panel == 'design'"
          />
          <Settings
            v-if="admin.panel == 'settings'"
          />
          <Dining
            v-if="admin.panel === 'dining'"
          />
          <TrailHub
            v-if="admin.panel === 'trailHub'"
          />
          <Weather
            v-if="admin.panel === 'weather'"
          />
          <GoogleCalendar
            v-if="admin.panel === 'googleCalendar'"
          />
          <Webcams
            v-if="admin.panel === 'webcams'"
          />
          <CustomTabs
            v-if="admin.panel === 'customTabs'"
          />
        </div><!-- /.container -->
      </div><!-- /.col-md-9 -->
    </div><!-- /.row -->
  </div><!-- /#admin -->
</template>

<script>
  import AdminNav from './AdminNav.vue'
  import Settings from './Settings.vue'
  import Design from './Design.vue'
  import Dining from './modules/Dining.vue'
  import TrailHub from './modules/TrailHub.vue'
  import Weather from './modules/Weather.vue'
  import GoogleCalendar from './modules/GoogleCalendar.vue'
  import Webcams from './modules/Webcams.vue'
  import CustomTabs from './modules/CustomTabs.vue'
  import { mapState } from 'vuex'
  const fb = require('../../firebaseConfig.js')

  export default {
    components: {
      AdminNav,
      Settings,
      Design,
      Dining,
      TrailHub,
      Weather,
      GoogleCalendar,
      Webcams,
      CustomTabs
    },
    computed: {
      ...mapState([
        'admin',
        'dashboard',
        'userProfile',
        'currentUser'
      ])
    },
    created() {
      if (this.$route.params.id) {
        this.$store.commit('fetchDashboard', {id: this.$route.params.id, customStyles: false})
      } else {
        if (this.currentUser) {
          fb.dashboardsCollection.where('createdBy', '==', this.currentUser.uid).limit(1).get().then(dashboards => {
            let dashboardData = dashboards.docs[0].data()
            dashboardData.id = dashboards.docs[0].id
            this.$router.push('/admin/' + dashboardData.id)
            this.$store.commit('fetchDashboard', {id: this.$route.params.id, customStyles: false})
          })
        } else {
          this.$router.push('/login')
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/Admin.vue